import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * Set item depth command
 *
 * @class SetItemDepthCommand
 * @extends AbstractCommand
 */
export default class SetItemDepthCommand extends AbstractCommand {
    constructor(item, depth) {
        super();
        this.item = item;
        this.initialDepth = this.item.get('depth');
        this.depth = depth || this.initialDepth;
    }

    /**
     * Is this a valid command?
     *
     * @return {boolean}
     */
    isValid() {
        return this.item.supportsDepth;
    }

    /**
     * Set depth
     *
     * @param {number} depth
     */
    setDepth(depth) {
        this.depth = depth;
    }

    /**
     * Execute command
     */
    execute() {
        if (!this.isValid()) {
            return;
        }

        this.item.set('depth', this.depth);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        if (!this.isValid()) {
            return;
        }

        this.item.set('depth', this.initialDepth);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Set ${this.item.attributes.type} depth`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.SetItemDepthCommand = SetItemDepthCommand;
